import {type NumberFormat, type RowValue} from '@/api/reporting';

const EMPTY = '—';

export function formatNumber(value: number | null, format: NumberFormat = 'integer'): string {
  if (value === null) {
    return EMPTY;
  }

  switch (format) {
    case 'percent': {
      return `${(value * 100).toFixed(1)}%`;
    }

    case 'decimal': {
      return value.toLocaleString(undefined, {maximumFractionDigits: 1});
    }

    case 'integer': {
      return Math.round(value).toLocaleString();
    }
  }
}

export function formatCell(value: RowValue, format?: NumberFormat): string {
  if (value === null) {
    return EMPTY;
  }

  if (typeof value === 'number') {
    return formatNumber(value, format);
  }

  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }

  return value;
}

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
// Dates come back as UTC calendar days (the service binds parameters as DATE), so label them in
// UTC too, or a chart viewed west of Greenwich shifts every point back a day.
const DAY_LABEL = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  timeZone: 'UTC'
});

/** An axis or tooltip label for an x value: calendar days read as `8 Oct`, anything else as-is. */
export function formatAxisValue(value: unknown): string {
  if (typeof value === 'string' && ISO_DATE.test(value)) {
    return DAY_LABEL.format(new Date(`${value}T00:00:00Z`));
  }

  return value === null || value === undefined ? '' : String(value);
}
